import React from 'react'
import IconWrapper from './IconWrapper'

export const MastodonIcon = props => (
    <IconWrapper {...props}>
        <svg
            version="1.1"
            x="0px"
            y="0px"
            width="24px"
            height="24px"
            viewBox="0 0 24 24"
            enableBackground="new 0 0 24 24"
            xmlSpace="preserve"
            aria-hidden="true"
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M16.703 18.175c2.944-.352 5.508-2.166 5.83-3.824C23.041 11.74 23 7.98 23 7.98c0-5.098-3.34-6.593-3.34-6.593C17.975.613 15.083.287 12.079.263h-.074C9 .287 6.11.613 4.426 1.386c0 0-3.34 1.495-3.34 6.593 0 .309-.002.634-.004.972-.004.94-.01 1.983.018 3.071.121 4.986.914 9.9 5.524 11.12 2.125.562 3.95.68 5.42.599 2.665-.148 4.16-.951 4.16-.951l-.087-1.934s-1.905.6-4.044.527c-2.119-.072-4.356-.228-4.699-2.83a5.335 5.335 0 01-.047-.73s2.08.509 4.716.63c1.612.074 3.124-.095 4.66-.278zm2.356-3.628V8.374c0-1.262-.321-2.264-.966-3.006-.666-.741-1.537-1.122-2.618-1.122-1.252 0-2.2.481-2.826 1.443l-.61 1.022-.609-1.022c-.626-.962-1.574-1.443-2.826-1.443-1.081 0-1.953.38-2.618 1.122-.645.742-.966 1.744-.966 3.006v6.173h2.445V8.556c0-1.263.532-1.905 1.595-1.905 1.175 0 1.764.76 1.764 2.265v3.28h2.431v-3.28c0-1.504.59-2.265 1.764-2.265 1.063 0 1.595.642 1.595 1.905v5.991h2.445z"
                clipRule="evenodd"
            ></path>
        </svg>
    </IconWrapper>
)

export default MastodonIcon
